import React from "react";

import { imageList } from "@/core/utils/imageList";
import { Idea } from "../model/types";
import { BgImage } from "@/core/components/bgImage/BgImage";

interface PartnershipPreviewProps {
  idea: Idea;
}

export const PartnershipPreview: React.FC<PartnershipPreviewProps> = ({
  idea,
}) => {
  if (
    !idea.partnership ||
    (Array.isArray(idea.partnership)
      ? idea.partnership.length === 0
      : typeof idea.partnership === "object" &&
        idea.partnership !== null &&
        Object.keys(idea.partnership).length === 0)
  ) {
    return null;
  }

  return (
    <div className="interested-partners-details">
      <h3 style={{ marginTop: "0px" }}>Partnership</h3>
      <div className="interested-partners">
        <div className="partners-avatars">
          {Object.values(idea.partnership as Record<string, any>)
            .slice(0, 4)
            .map((p, i) => {
              return (
                <div
                  key={p.id || i}
                  className="partner-avatar-wrapper"
                  style={{
                    transform: i > 0 ? `translateX(-${18 * i}px)` : "none",
                    zIndex: i > 0 ? 2 + (i - 1) : 1,
                  }}
                >
                  <div className="company-logo placeholder">
                    <BgImage
                      img={p.partner.logo_uri || imageList.noOrgimage}
                      altImage={imageList.noOrgimage}
                    />
                  </div>
                </div>
              );
            })}
          {idea.partnership &&
            !Array.isArray(idea.partnership) &&
            typeof idea.partnership === "object" &&
            idea.partnership !== null &&
            Object.keys(idea.partnership).length > 4 && (
              <div
                className="more-count"
                style={{
                  transform: `translateX(-${21 * 4}px)`,
                  zIndex: 2 + Object.values(idea?.partnership).length,
                }}
              >
                +{Object.keys(idea.partnership).length - 4}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
